import { TaskTypes } from "@repo/utils";
import { DEFAULT_DESCRIPTION_COLUMN_IDENTIFIER } from "@repo/structure";

export function libraryChildMap(child, idKey) {
  const values = child.values?.length
    ? child.values.reduce(
        (values, workType) => ({
          ...values,
          ...workType,
        }),
        {}
      )
    : {};

  const newChildObj = {
    type: TaskTypes.WORKLOAD,
    name: child.name,
    content: child.content,
    parent: child.parent,
    children: child.children?.length
      ? child.children.map((e) => libraryChildMap(e, idKey))
      : undefined,
    values,
    libraryStatus: child.status,
    libraryTask: true,
  };
  if(child.content)
    newChildObj.descriptions = { [DEFAULT_DESCRIPTION_COLUMN_IDENTIFIER]: { content: child.content } };

  newChildObj[idKey] = child.id;

  return newChildObj;
}
